import { createSlice } from '@reduxjs/toolkit';

import dvdsDataRaw from 'data/dvds.json';

import { Dvd, DvdsState } from 'interfaces';

const initialStateDefault: DvdsState = {
  dvds: [],
  dvdDetails: null
};

const dvdsData: Dvd[] = dvdsDataRaw as unknown as Dvd[];

const dvdsSlice = createSlice({
  name: 'dvds',
  initialState: initialStateDefault,
  reducers: {
    loadDvds (state) {
      return {
        ...state,
        dvds: dvdsData
      };
    },
    getDvdDetails (state, action) {
      const { dvdId } = action.payload;
      const dvdDetails = dvdsData.filter((el) => el.id === dvdId)[0];
      // const sameTypeDvd = dvdsData.filter((el) => el.typeId === dvdDetails.typeId);
      // const albumNumberIndex = sameTypeDvd.findIndex(i => i.id === dvdDetails.id);

      return {
        ...initialStateDefault,
        dvdDetails: {
          ...initialStateDefault.dvdDetails,
          ...dvdDetails
        }
      };
    }
  }
});

export const { loadDvds, getDvdDetails } = dvdsSlice.actions;

export default dvdsSlice.reducer;
